<template>
  <div style="margin-top:100px; margin-left:50px; margin-right:50px">
    <loader></loader>
    <no-habilitado v-if="!habilitado" perfil="Administradores"></no-habilitado>
    <app-error v-if="error" :errorMensaje="errorMensaje"></app-error>

    <div class="row">
      <div class="col-6">
        <h1>Administrar cursos</h1>
      </div>
      <div class="col-6" style="text-align:right">
        <router-link to="/Admin/Cursos/Nuevo/Curso" tag="div" style="cursor:pointer">
          <img
            src="public/images/arkidians/nuevo.svg"
            width="60px"
            alt="Arkidia"
            style="border-radius:100%; background-color:#007bff"
          />
        </router-link>
      </div>
    </div>

    <hr />
    <div>
      <div class="card" style="margin-bottom:10px" v-for="curso in cursos" v-bind:key="curso.id">
        <div class="card-body" :style="'border-right:10px solid ' + curso.estado.color">
          <div class="row">
            <div class="col-8">
              <h5 class="card-title">
                <a :style="'color: #' + curso.categoria.color"># {{curso.id}}</a>
                {{curso.nombre}}
              </h5>

              <router-link
                :to="'/Admin/Cursos/Modifica/'+curso.id"
                tag="a"
                style="cursor:pointer"
                class="accion"
              >Editar Curso</router-link>

              <router-link
                :to="'/Activity/'+curso.id"
                tag="a"
                style="cursor:pointer"
                class="accion"
              >Previsualizar</router-link>

              <a @click="eliminarModal(curso)" class="accion" style="color:darkred">Eliminar</a>
            </div>
            <div class="col-4" style="text-align:right">
              <h5 class="card-title">{{curso.categoria.nombre}}</h5>
              <a
                v-if="curso.estado.descripcion == 'Publicado'"
                class="accion"
                @click="despublicarCurso(curso)"
              >Despublicar</a>
              <a
                v-if="curso.estado.descripcion == 'Borrador'"
                class="accion"
                @click="publicarCurso(curso)"
              >Publicar</a>
              <a style="margin:0px">{{curso.estado.descripcion}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="eliminar-modal" hide-footer title="Eliminar Curso">
      <div class="d-block text-center">
        <h5>Vas a eliminar el curso</h5>
        <h4>cursoSeleccionado.nombre</h4>
      </div>
      <b-button
        class="mt-3"
        variant="danger"
        block
        @click="eliminarCurso(cursoSeleccionado)"
      >Eliminar</b-button>
      <b-button class="mt-2" variant="warning" block @click="cerrarEliminar">Cerrar</b-button>
    </b-modal>

    <b-modal ref="error-modal" hide-footer title="Error">
      <div class="d-block text-center">
        <h4>{{errorMessage}}</h4>
        <b-button class="mt-2" variant="danger" block @click="cerrarError">Cerrar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NoHabilitado from "../shared/NoHabilitado";
import appError from "../shared/Error";
import Loader from "../shared/Loader";

export default {
  name: "app",
  data() {
    return {
      cursos: [],
      error: false,
      errorMessage: "",
      perfil: "",
      habilitado: false
    };
  },
  methods: {
    buscarCursos() {
      fetch(this.pathAPI + "cursos.php?usuario=" + this.userLogged.usuario)
        .then(response => response.json())
        .then(data => {
          this.cursos = [];
          data.forEach(element => {
            this.cursos.push({
              id: parseInt(element.id_curso),
              nombre: element.nombre_curso,
              idCat: element.id_categoria,
              categoria: this.buscarCategoria(element.id_categoria),
              proveedor: element.nombre_proveedor,
              estado: this.buscarEstado(element.estado_curso)
            });
            const loader = document.querySelector(".loader");
            loader.className += " hidden";
          });
        });
    },
    eliminarModal(curso) {
      this.$refs["eliminar-modal"].show();
    },
    cerrarEliminar() {
      this.$refs["eliminar-modal"].hide();
    },
    cerrarError() {
      this.$refs["error-modal"].hide();
    },

    eliminarCurso(curso) {
      var self = this;
      self.errorMessageDes = "";
      self.successMessageDes = "";

      fetch(
        this.pathAPI +
          "cursos.php?id_curso=" +
          curso.id +
          "&usuario=" +
          this.userLogged.user,
        {
          method: "DELETE"
        }
      ).then(function(response) {
        for (var i = 0; i < self.cursos.length; i++) {
          if (self.cursos[i].id === curso.id) {
            self.cursos.splice(i, 1);
          }
        }
        self.$refs["eliminar-modal"].hide();
      });
    },

    publicarCurso(curso) {
      var fetchApi =
        this.pathAPI +
        "cursos.php?usuario=" +
        this.userLogged.user +
        "&id_curso=" +
        curso.id;
      fetch(fetchApi)
        .then(response => response.json())
        .then(data => {
          this.modificarCurso(data, "P");
        });
    },
    despublicarCurso(curso) {
      var fetchApi =
        this.pathAPI +
        "cursos.php?usuario=" +
        this.userLogged.user +
        "&id_curso=" +
        curso.id;
      fetch(fetchApi)
        .then(response => response.json())
        .then(data => {
          this.modificarCurso(data, "B");
        });
    },

    modificarCurso(curso, estado) {
      var self = this;
      var bodyApi;
      bodyApi =
        "id_curso=" +
        curso.id_curso +
        "&usuario=" +
        this.userLogged.user +
        "&id_categoria=" +
        curso.id_categoria +
        "&nombre_curso=" +
        curso.nombre_curso +
        "&detalle_curso=" +
        curso.detalle_curso +
        "&edad_desde=" +
        curso.edad_desde +
        "&edad_hasta=" +
        curso.edad_hasta +
        "&id_proveedor=1" +
        "&estado_curso=" +
        estado;
      fetch(self.pathAPI + "cursos.php?" + bodyApi, {
        method: "PUT",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var respuesta;
          respuesta = response.json();
          respuesta.then(function(result) {
            if (result.resultado === "ERROR") {
              console.log(respuesta);
            } else {
              var i;
              for (i = 0; i < self.cursos.length; i++) {
                if (self.cursos[i].id == curso.id_curso) {
                  self.cursos[i].estado = self.buscarEstado(estado);
                }
              }
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },

    buscarEstado(estado) {
      if (estado === "B") return { descripcion: "Borrador", color: "#ffc107" };
      if (estado === "P") return { descripcion: "Publicado", color: "#00c016" };
    },
    buscarCategoria(id) {
      var i;
      for (i = 0; i < this.categorias.length; i++) {
        if (this.categorias[i].id == id) {
          return this.categorias[i];
        }
      }
    },
    nuevoCurso() {
      sessionStorage.cursoSeleccionado = "";
      this.$store.state.cursoSeleccionado = "";
      this.$router.push({ path: "/Admin/Cursos/Nuevo" });
    },

    editarCurso(curso) {
      this.$store.state.cursoSeleccionado = curso;
      sessionStorage.cursoSeleccionado = this.cursoSeleccionado;
      this.$router.push({ path: "/Admin/Cursos/Nuevo" });
    }
  },
  computed: {
    ...mapGetters(["pathAPI", "userLogged", "categorias", "cursoSeleccionado"])
  },
  components: {
    NoHabilitado: NoHabilitado,
    appError: appError,
    Loader: Loader
  },

  mounted: function() {
    if (this.userLogged.profile == "ADMINISTRADOR") {
      this.habilitado = true;
      this.buscarCursos();
    } else {
      this.perfil = "Administradores";
    }
  }
};
</script>


<style scoped>
.lds-circle {
  display: inline-block;
  transform: translateZ(1px);
}
.lds-circle > div {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-right: 8px;
  border-radius: 50%;
  background: rgb(16, 131, 112);
  animation: lds-circle 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.accion {
  background: #f0eeee;
  padding: 5px 20px;
  border-radius: 15px;
  cursor: pointer;
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminCursos.vue